import request from '@/utils/request'


export function addOffer(data) {
    return request({
        url: `api/serviceCenter/offer/addOffer`,
        method: 'post',
        data,
    })
}

export function upDateOffer(data) {
    return request({
        url: `api/serviceCenter/offer/upDateOffer`,
        method: 'post',
        data,
    })
}

export function selectOffer(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/offer/selectOffer?access=${data}`,
        method: 'post',
       // data,
    })
}

export function bathDeleteOffer(data) {
    return request({
        url: `api/serviceCenter/offer/bathDeleteOffer`,
        method: 'post',
        data,
    })
}

